import {BettingSvc} from '../services/betting.service';
import {GameSvc} from '../services/game.service';

/**
 * System bet validator
 * @module directives/future bet validator
 * @type {{update: (function(*, *))}}
 */

export const SystemBetValidator = {
    update(element, binding){

        if (/[\d\.]+/i.test(element.value)) {

            let newValue = Number(element.value);
            let bettingSvc = BettingSvc.getBettingSvc();
            let gameSvc = GameSvc.getGameSvc();

            if (bettingSvc.ticket.input.length && bettingSvc.ticket.input[bettingSvc.ticket.input.length - 1] === '') {
                bettingSvc.ticket.input.pop();
            }

            let pickedBalls = Number(bettingSvc.ticket.input.length || bettingSvc.random);

            if (newValue > gameSvc.spotNumber || newValue >= pickedBalls || newValue < 1) {
                newValue = '';
                BettingSvc.getBettingSvc().system = '';
            }

            element.value = newValue;
            binding.value = element.value;

        } else {

            let newValue = element.value.replace(/[a-zA-Z]+/ig, '');
            element.value = newValue;
            binding.value = element.value;
        }
    },
};


// WEBPACK FOOTER //
// systembet_validator.js